export default __webpack_public_path__ + "static/jetson_vehicle-990e28d81d7317360daa34e3c7541c12.png";